import { Col, DatePicker, Divider, Input, InputNumber, Row } from 'antd'

import LinkAddress from 'component/link/link-address'
import { useVestingContext } from 'context/vesting-context-provider'

const VestingManagement = () => {
  const {
    scVesting,
    tokenAddress,
    firstRelease,
    startTime,
    cliffDuration,
    totalPeriods,
    timePerPeriod,
  } = useVestingContext()

  return (
    <>
      <div className="main-title" style={{ marginBottom: 20 }}>
        Vesting Configuration
      </div>
      <div
        style={{
          margin: 'auto',
          padding: 20,
          borderRadius: 20,
          border: '1px solid black',
          background: 'white',
          textAlign: 'start',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            marginBottom: 10,
          }}
        >
          <h2 style={{ marginTop: 0, marginBottom: 5 }}>SC Vesting: </h2>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <LinkAddress address={scVesting} max={0} />
          </div>
        </div>
        <Row gutter={[16, 16]}>
          <Col span={11}>
            <Row gutter={16}>
              <Col span={8}>
                <label style={{ textAlign: 'start' }}>
                  <strong>Token Address:</strong>
                </label>
              </Col>
              <Col span={16}>
                <Input
                  placeholder="0x..."
                  value={tokenAddress} // Show full or formatted address
                  disabled={true}
                />
              </Col>
            </Row>
          </Col>
          <Divider type="vertical" style={{ height: 'auto' }} />
          <Col span={11}>
            <Row gutter={16}>
              <Col span={8}>
                <label style={{ textAlign: 'start' }}>
                  <strong>First Release Percentage (%):</strong>
                </label>
              </Col>
              <Col span={16}>
                <InputNumber
                  placeholder="Input a number"
                  value={firstRelease}
                  style={{ width: '100%' }}
                  min={0}
                  disabled={true}
                />
              </Col>
            </Row>
          </Col>
          <Col span={11}>
            <Row gutter={16}>
              <Col span={8}>
                <label style={{ textAlign: 'start' }}>
                  <strong>Vesting Start Time:</strong>
                </label>
              </Col>
              <Col span={16}>
                <DatePicker showTime value={startTime} disabled={true} style={{ width: '100%' }} />
              </Col>
            </Row>
          </Col>
          <Divider type="vertical" style={{ height: 'auto' }} />
          <Col span={11}>
            <Row gutter={16}>
              <Col span={8}>
                <label style={{ textAlign: 'start' }}>
                  <strong>Cliff Duration (days):</strong>
                </label>
              </Col>
              <Col span={16}>
                <InputNumber
                  placeholder="Input a number"
                  value={cliffDuration}
                  style={{ width: '100%' }}
                  min={0}
                  step={1}
                  disabled={true}
                />
              </Col>
            </Row>
          </Col>
          <Col span={11}>
            <Row gutter={16}>
              <Col span={8}>
                <label style={{ textAlign: 'start' }}>
                  <strong>Total Vesting Periods:</strong>
                </label>
              </Col>
              <Col span={16}>
                <InputNumber
                  placeholder="Input a number"
                  value={totalPeriods}
                  style={{ width: '100%' }}
                  min={0}
                  disabled={true}
                />
              </Col>
            </Row>
          </Col>
          <Divider type="vertical" style={{ height: 'auto' }} />
          <Col span={11}>
            <Row gutter={16}>
              <Col span={8}>
                <label style={{ textAlign: 'start' }}>
                  <strong>Time Per Period (days):</strong>
                </label>
              </Col>
              <Col span={16}>
                <InputNumber
                  placeholder="Input a number"
                  value={timePerPeriod}
                  style={{ width: '100%' }}
                  min={0}
                  step={1}
                  disabled={true}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </>
  )
}

export default VestingManagement
